type BrowserProcessShim = {
  env?: {
    NODE_ENV?: string;
  };
  emit?: (...args: unknown[]) => void;
};

const globalScope = globalThis as typeof globalThis & {
  process?: unknown;
};

const currentProcess = globalScope.process as BrowserProcessShim | undefined;

if (!currentProcess || typeof currentProcess !== 'object') {
  (globalScope as { process?: unknown }).process = {
    env: {
      NODE_ENV: 'production',
    },
  } as BrowserProcessShim;
} else {
  currentProcess.env ??= {};
  currentProcess.env.NODE_ENV ??= 'production';
}

export {};
